import {
  AssistantBotAssistantType,
  AssistantBotAvailableAssistant
} from 'common/types/assistantBot'

export const createNodeTemplate = `
_node_title = '##node_title##'
_module_id = '##module_id##'
_node_definition = """##node_definition##"""
_node_id = current_model.previewNodeIdFromTitle('node1',node_title=_node_title)['preview_id']

if current_model.existNode(_node_id):
    _node_id = current_model.getNextIdentifier(_node_id)

_x=None
_y=None
pos = current_model.getAPlace(
                _module_id, 
                x=100, 
                y=100, 
                w=180, 
                h=40, 
                direction='down'
            )
if pos:
    _x = int(pos['x'])
    _y = int(pos['y'])     

_new_node = current_model.createNode(
    identifier=_node_id, 
    moduleId=_module_id, 
    x=_x,
    y=_y,
    w=180, 
    h=40)

_node_id = _new_node.identifier
_new_node.title = _node_title

_new_node.definition = _node_definition.replace(_node_id,f'_{_node_id}')
result = _new_node.identifier
`

export const RESPONSE_SOURCES_PREFIX = '##*##'

export const PYPLAN_ASSISTANT: AssistantBotAvailableAssistant = {
  assistantType: AssistantBotAssistantType.pyplan,
  label: 'Pyplan',
  labelBackgroundColor: '#FFD76B',
  labelColor: '#000000',
  assistantId: 'pyplan_assistant'
}

export const PYPLAN_CODE_ASSISTANT: AssistantBotAvailableAssistant = {
  assistantType: AssistantBotAssistantType.code,
  label: 'Code Assistant',
  labelBackgroundColor: '#FFD76B',
  labelColor: '#000000',
  assistantId: 'pyplan_code_assistant'
}

export const PLANNER_ASSISTANT: AssistantBotAvailableAssistant = {
  assistantType: AssistantBotAssistantType.planner,
  label: 'Planner',
  labelBackgroundColor: '#FFB6C1',
  labelColor: '#000000',
  assistantId: 'planner_assistant'
}

export const VISUALIZER_ASSISTANT: AssistantBotAvailableAssistant = {
  assistantType: AssistantBotAssistantType.visualizer,
  label: 'Visualizer',
  labelBackgroundColor: '#FFB6C1',
  labelColor: '#000000',
  assistantId: 'visualizer_assistant'
}
